const ModalDeletePartEnum = Object.freeze({
  FROM_BUDGETING: 0,
  FROM_EXTRAS_AND_CONTRADICTIONS: 1,
})

export default ModalDeletePartEnum
